<template>
  <div id="app">
    <!-- <Header ref="header"/> -->

    <md-app md-mode="reveal">
      <md-app-toolbar class="md-primary">
        <md-button class="md-icon-button" @click="menuVisible = !menuVisible">
          <md-icon>menu</md-icon>
        </md-button>
        <span class="md-title">{{title}}</span>
        <!-- <img class="logo" src="./assets/logo-side320.png" height="64px"> -->
      </md-app-toolbar>

      <md-app-drawer :md-active.sync="menuVisible">
        <md-toolbar class="md-transparent" md-elevation="0">Navigation</md-toolbar>

        <md-list>
        <md-list-item @click="toHome">
          <md-icon>home</md-icon>
            <span class="md-list-item-text">Home</span>
        </md-list-item>
        <md-list-item @click="toWJA">
          <md-icon>edit</md-icon>
            <span class="md-list-item-text">どうぶつひらがなカタカナ</span>
          </md-list-item>
        <md-list-item @click="toCredit">
            <md-icon>new_releases</md-icon>
            <span class="md-list-item-text">クレジット</span>
          </md-list-item>
        </md-list>
        <md-card>
          <Adsense
            data-ad-client="ca-pub-3855984555521591"
            data-ad-slot="1292029350">
          </Adsense>
        </md-card>
      </md-app-drawer>

      <md-app-content>
        <router-view ref="component"
         :imageNo='writeImageNo'
         @selectRedirect="selectRedirect"
         @toggleContentsVisible="toggleContentsVisible"
         @setTitle="setTitle"
         />
      </md-app-content>
    </md-app>
    <div class="spinner_area" v-bind:class="{hideDisp:!contentsVisible}">
    <div class="spinner">
      <md-progress-spinner :md-diameter="150" :md-stroke="10" md-mode="indeterminate"></md-progress-spinner>
      <span class="spinnerWord">Image<br>Loading...</span>
    </div>
    <div class="progressBar">
      <md-progress-bar class="md-accent" md-mode="indeterminate"></md-progress-bar>
    </div>
  </div>
    <Footer ref="footer" @onClearCanvas="onClearCanvas" @nextCanvas="nextCanvas" @beforeCanvas="beforeCanvas"/>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
export default {
  name: 'App',
  props: {
    imageNo: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      title: 'Gakumon Diamond Works Co.,Ltd.',
      writeImageNo: this.imageNo,
      menuVisible: false,
      contentsVisible: false
    }
  },
  components: {
    Header,
    Footer
  },
  methods: {
    // キャンバスをクリアする
    setTitle: function (title) {
      this.debug('App.vue - setTitle : ' + title)
      if (title) {
        this.title = title
      } else {
        this.title = 'Gakumon Diamond Works Co.,Ltd.'
      }
    },
    // キャンバスをクリアする
    onClearCanvas: function () {
      // 子コンポーネントのクリアを呼び出す
      this.$refs.component.onClearCanvas()
    },
    nextCanvas: function () {
      // 子コンポーネントの次へを呼び出す
      this.$refs.component.nextCanvas()
    },
    beforeCanvas: function () {
      // 子コンポーネントの前へを呼び出す
      this.$refs.component.beforeCanvas()
    },
    selectRedirect: function (selectNo) {
      this.debug('selectRedirect : ' + selectNo + 'の画像を呼び出しました')
      this.writeImageNo = selectNo
      this.debug('遷移先に受け渡す値 : this.writeImageNo : ' + this.writeImageNo)
      this.$router.push({ name: 'Redirect', props: { imageNo: this.writeImageNo } })
    },
    toggleContentsVisible: function () {
      this.contentsVisible = !this.contentsVisible
    },
    toCredit: function () {
      this.menuVisible = !this.menuVisible
      this.$router.push({ name: 'Credit' })
    },
    toHome: function () {
      this.menuVisible = !this.menuVisible
      this.$router.push({ name: 'Index' })
    },
    toWJA: function () {
      this.menuVisible = !this.menuVisible
      var appNum = 1
      this.setTitle(this.getAppsInfo(appNum).title)
      this.$router.push({ name: this.getAppsInfo(appNum).link })
    },
    getImageNo: function () {
      return this.writeImageNo
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>
<style lang="scss" scoped>
.hideDisp {
  display: none !important;
}
.md-app {
  min-height: 100vh;
}
.spinner {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.spinnerWord {
  position: absolute;
  font-weight: bold
}
.progressBar {
  width: 100%;
  position: fixed;
  margin: auto;
  bottom: 60px;
  z-index: 10000
}
</style>



// WEBPACK FOOTER //
// src/App.vue